import { useQuery } from "@tanstack/react-query";
import { restApiRequest, EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import { mockData } from "src/utils/hooks/company/useOrganizationUnits";
import sortByField from "src/utils/jsHelpers/sortByField";

const useCompanyOrganizationUnitsOptions = (
  companyId: string,
  enabled: boolean
) =>
  useQuery({
    enabled,
    queryKey: [
      "employee-management-organization-units",
      { companyId, itemsPerPage: 10000 },
    ],
    queryFn: () =>
      restApiRequest(
        EMPLOYEE_MANAGEMENT_SERVICE,
        `/organization-units?itemsPerPage=10000&companyId=${companyId}`,
        "GET",
        {},
        mockData
      ),
    initialData: [],
    select: (
      data: {
        id: string;
        name: string;
      }[]
    ) =>
      sortByField(
        data?.map(({ name, id }) => ({
          value: id,
          label: name,
        })) || [],
        "label"
      ),
  });

export default useCompanyOrganizationUnitsOptions;
